import gql from 'graphql-tag';

export const GET_STATEMENTS = gql`
  query GetStatements($planId: Int!) {
    plan(id: $planId) {
      id
      statements {
        id
        issuedAt
        refundedAmountCents
        status
        total
        kwh {
          total
        }
        paymentTransactions {
          id
          disputeId
        }
      }
      mostRecentStatement {
        id
      }
      balances {
        id
        pastDueCents
        balanceCents
        balanceDueCents
      }
      paymentLink {
        id
        stripeCheckoutUrl
      }
    }
  }
`;

export const getStatementsMock = {
  plan: {
    id: 1,
    mostRecentStatement: {
      id: 2,
    },
    statements: [
      {
        id: 2,
        issuedAt: '2020-01-01',
        refundedAmountCents: 100,
        total: 500,
        kwh: {
          total: 500,
        },
        paymentTransactions: [
          {
            id: 99,
            disputeId: null,
          },
        ],
      },
    ],
  },
};
